import { useEffect, useState } from "react";

interface Props {
  endsAt: number | null;
  label?: string;
}

export function PhaseTimer({ endsAt, label }: Props) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 200);
    return () => window.clearInterval(id);
  }, []);
  if (!endsAt) return null;
  const remaining = Math.max(0, endsAt - now);
  const seconds = Math.ceil(remaining / 1000);
  const danger = remaining < 10_000;
  return (
    <div className={`timer ${danger ? "timer-danger" : ""}`}>
      {label && <span className="timer-label">{label}</span>}
      <span className="timer-value">{seconds}s</span>
    </div>
  );
}
